import React from 'react';
import { Input as InputAntd } from 'antd';

interface Props {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
}

const Input = ({ value, onChange, placeholder }: Props) => {
  return (
    <InputAntd
      size='large'
      style={{ height: '48px', fontSize: '16px', fontWeight: '500', borderRadius: '4px' }}
      value={value}
      onChange={(e) => onChange?.(e.target.value)}
      placeholder={placeholder}
    />
  );
};

export default Input;
